<div class="gen-legend-title" [ngClass]="{'align-right': alignRight}">
  {{ title | translate }}
</div>
<div class="gen-legend">
  <div *ngFor="let item of items" class="gen-legend-item-wrapper">
    <span class="gen-legend-item {{item?.cssClass}}"
          genTooltip
          tooltipPosition="BOTTOM"
          tooltipText="{{item?.tooltipText}}"
          tooltipShow="true"
          [ngStyle]="{backgroundColor: item.itemColor}"><span class="inline-text"*ngIf="item?.isInline" [ngStyle]="{color: item.textColor}">{{ getValueOrItsTranslation(item) | translate}}</span></span>
    <span *ngIf="!item?.isInline" class="gen-legend-text" [ngStyle]="{color: item.textColor}">{{ getValueOrItsTranslation(item) | translate}}</span>
  </div>
</div>
